import { render, staticRenderFns } from "./OfferAlternativeRooms.vue?vue&type=template&id=bc757216&"
import script from "./OfferAlternativeRooms.vue?vue&type=script&lang=js&"
export * from "./OfferAlternativeRooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc757216')) {
      api.createRecord('bc757216', component.options)
    } else {
      api.reload('bc757216', component.options)
    }
    module.hot.accept("./OfferAlternativeRooms.vue?vue&type=template&id=bc757216&", function () {
      api.rerender('bc757216', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/reservationAdministration/OfferAlternativeRooms.vue"
export default component.exports